import { useAdminStore } from "@voix/store/adminStore";
import { $voixNuxtApi } from "@voix/voix-layer/composables/voixNuxtApi";
async function mediaSelected(variables) {
  const adminStore = useAdminStore();
  adminStore.isLoading = true;
  const request = await $voixNuxtApi(
    `/api/admin/voix/media/${variables.client}/selected`,
    {
      method: "POST",
      body: variables
    }
  );
  adminStore.isLoading = false;
  return request;
}
export {
  mediaSelected
};
